import { EVENT_SERVICE } from './../../providers/service.providers';
import { EventService } from '../../services/event.service';
import { Component, Inject, OnInit } from '@angular/core';
import { Event } from '../../models/Event';
import { LocalizableError } from 'src/app/models/LocalizableError';
import { debounceTime } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { LabelsService } from 'src/app/services/labels.service';
import { TimeDisplayConfig } from '../../../assets/config/config';
import { DatePipe, formatDate } from '@angular/common';
import { DateFormatter } from 'src/app/helpers/DateFormatter';
// Axtrion:
import { ImageHelper } from "../../helpers/ImageHelper";
import { ActivatedRoute } from '@angular/router';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
    public allEvents: Event[];
    public filteredEvents: Event[];
    public isLoading: boolean;
    public error?: LocalizableError;
    private subject: Subject<string> = new Subject();
    private timeDisplayConfig: any;
    public qualityDropdown = 'Featured Events';
    public regionDropdown = 'Alle Veranstaltungen';
    public sortDropdown = 'date-asc';
    
    // Axtrion
    private region: string;
    private defaultImageUrlCrmHosted = 'VdUKacheln.png';
    public page = 0;
    public pageSize = 10;
    public collectionSize;
    public eventsList: Event[];
    public sortLabel = 'Sort By'; // Label for Sort By Dropdown
    public eventQuality = 'Featured Events'; // Label for View As Dropdown
    public availableRegions = ['Alle Veranstaltungen', 'Aufsichtsratsseminar', 'Bundesweit', 'Baden', 'Bayern-Nord', 'Bayern-Süd', 'Berlin/Brandenburg', 'Bremen-Weser-Ems', 
                                'Hamburg/Schleswig-Holstein','Hessen', 'Mecklenburg-Vorpommern', 'Niedersachsen', 'Rheinland', 'Ruhrgebiet', 
                                'Sachsen/Sachsen-Anhalt', 'Thüringen', 'Westfalen', 'Württemberg', "Internationale Kommission", "MINT Kommission", 'Wirtschaftskommission', 'Online Formate'];

    constructor(
        @Inject(EVENT_SERVICE) private eventService: EventService,
        private labelsService: LabelsService,
        private imageHelper: ImageHelper, // Axtrion
        private datePipe: DatePipe,
        private route: ActivatedRoute) {
            
    }

    ngOnInit(): void {
        window.scroll({ 
            top: 0, 
            left: 0, 
            behavior: 'smooth' 
        });

        if(this.route.snapshot.queryParams['region']) {
            let temp = this.route.snapshot.queryParams['region'];            
            if(this.availableRegions.includes(temp)){
                this.region = temp;
            }
        }
        
        this.timeDisplayConfig = TimeDisplayConfig;
        this.loadPublishedEvents();
        this.subject.pipe(
            debounceTime(300)
        ).subscribe(searchTextValue => {
            this.handleSearch(searchTextValue);
            this.refreshEvents();
        });
    }

    refreshEvents() {
        this.eventsList = this.filteredEvents
          .map((event, i) => ({id: i + 1, ...event}))
          .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
          this.collectionSize = this.filteredEvents.length;
    }

    private loadPublishedEvents() {
        this.isLoading = true;
        this.eventService.getPublishedEvents().subscribe(
            events => {
                // EVENT TYPE WITH INTERN WILL NOT DIPLAY ON WEBSITE
                this.allEvents = events.filter(function (el) {
                    return (el.eventType != 100000003) && (el.readableEventId != 'Jahresversammlung_2025_Mitgliederversammlung' && el.readableEventId != 'Jahresversammlung_2024204903327');
                });
                this.filteredEvents = this.allEvents;
                if(this.eventQuality=='Featured Events'){
                    this.orderEvents("date-asc");// Axtrion: sort by date by default
                    this.handleSearch('');
                    this.collectionSize = this.filteredEvents.length;
                    this.showEvents('Featured Events');
                } else if (this.eventQuality=='Past Events'){
                    this.orderEvents("date-asc");// Axtrion: sort by date by default
                    this.handleSearch('');
                    this.collectionSize = this.filteredEvents.length;
                    this.showEvents('Past Events');
                } else {
                    this.orderEvents("date-asc");// Axtrion: sort by date by default
                    this.handleSearch('');
                    this.collectionSize = this.filteredEvents.length;
                    this.showEvents('All Events');
                }
                
                if(this.region != 'Alle Veranstaltungen'){                    
                    this.Axt_setRegion(this.region);
                    this.regionDropdown = this.region;
                }
                
                this.isLoading = false;
            },
            (error: LocalizableError) => this.handleErrorResponse(error)
        );
    }

    private handleErrorResponse(error: LocalizableError) {
        this.error = error;
        this.isLoading = false;
    }

    public translateLabel(translationKey: string, defaultValue: string): Observable<string> {
        return this.labelsService.translateLabel(translationKey, defaultValue);
    }

    private getAreaLabel(event: Event): string {
        let date = this.getDateString(event);
        let building = event.building ? `at ${event.building.name}` : "";
        return `${event.eventName} on ${date} ${building}`;
    }

    public getDateString(event: Event): string {
        let dateSettings = DateFormatter.getDateSettings();
        
        if(dateSettings.convertToLocalDate){
            return DateFormatter.formatRangedDate(this.datePipe, event.startDateUTC, event.endDateUTC);
        }
        else{
            return DateFormatter.formatRangedDate(this.datePipe, event.startDate, event.endDate, event.timeZone);
        }
    }
    public Axt_getDateLocation(event: Event): string { // Axtrion
        let dateSettings = DateFormatter.getDateSettings();
        let building = event.building ? ` - ${event.building.name}, ${event.building.city}` : "";
        
        if(dateSettings.convertToLocalDate)
            return DateFormatter.Axt_formatDate(this.datePipe, event.startDateUTC)+building;
        else
            return DateFormatter.Axt_formatDate(this.datePipe, event.startDate)+building;
    }
    public Axt_getRegion(event: Event):string { // Axtrion
        try {
            return event.cr9fc_regionen;
        } catch {
            return "";
        }
    }
    public Axt_getCurrentRegion(): string {// Axtrion
        return this.region ? this.region : "Alle Veranstaltungen";
    }
    public Axt_setRegion(reg: string) {// Axtrion
        this.isLoading = true;
        this.filteredEvents = this.allEvents;
        this.showEvents(this.eventQuality);
        this.region = reg;
        this.search(reg==="Alle Veranstaltungen" ? `${this.loadPublishedEvents()}` : reg);
        this.page = 0;
        this.isLoading = false;
    }
    public Axt_getBannerImage() {
        return "https://mktdplp102neda.blob.core.windows.net/org-3eb8087012bd4363868de7b8f64af9f2/bd49dc2e-95ad-eb11-8236-0022489b47d0/XjK2dRAiQ07ztE39oMSuKGngqrAbxfj2Jo5eoXJ-C2g!-160x120?20210930T090829000Z";
        return this.imageHelper.getImageUrl(this.defaultImageUrlCrmHosted);
    }

    handleSearch(searchText: string) {
        if (searchText) {
            searchText = searchText.toLocaleLowerCase();
        }
        this.filteredEvents = this.filteredEvents.filter((it: Event) => {
            //return it.eventName.toString().toLocaleLowerCase().includes(searchText);
            let building_name = (it.building && it.building.name) ? it.building.name : "";
            let building_city = (it.building && it.building.city) ? it.building.city : "";
            let regions       = (it.cr9fc_regionen) ? it.cr9fc_regionen : "";
            // console.log("handleSearch: cr9fc_regionen:"+ regions);
            // return ((it.eventName.toString().toLocaleLowerCase().includes(searchText) 
            //         || building_name.toString().toLocaleLowerCase().includes(searchText)//Axtrion: search for location name!
            //         || building_city.toString().toLocaleLowerCase().includes(searchText)//Axtrion: search for location city!
            //         ) || regions.toString().toLocaleLowerCase().includes(searchText)//Axtrion: search for regions!
            //         )
            return ((it.eventName.toString().toLocaleLowerCase().includes(searchText)
                    ) || regions.toString().toLocaleLowerCase().includes(searchText)//Axtrion: search for regions!
                    )
        });
    }

    search(searchText: string) {
        this.subject.next(searchText);
    }

    // ============ DROPDOWN FOR EVENTS VIEW AS ============ //
    showEvents(val: string){
        
        if(val == 'Featured Events'){
            this.filteredEvents = this.allEvents.filter(function (el) {                
                return (new Date(el.startDateUTC) > new Date());
            });
            this.refreshEvents();
            this.eventQuality = val;
            this.region = this.region ? this.region : 'Alle Veranstaltungen';
        }
        else if (val == 'All Events'){
            this.filteredEvents = this.allEvents.sort((a, b) => { return <any>new Date(a.startDate.toString()) - <any>new Date(b.startDate.toString()) });
            this.refreshEvents();
            this.eventQuality = val;
            this.region = 'Alle Veranstaltungen';
        }
        else if(val == 'Past Events'){
            this.filteredEvents = this.allEvents.filter(function (el) {                
                return (new Date(el.startDateUTC) < new Date());
            });
            this.filteredEvents.sort((a, b) => {
                return Date.parse(b.startDateUTC.toString()) - Date.parse(a.startDateUTC.toString());
            })
            this.refreshEvents();
            this.eventQuality = val;
            this.region = 'Alle Veranstaltungen';
        }
    }

    // ============ DROPDOWN FOR ORDER BY SORTING ============ //
    orderEvents(order: string) {
        if (order === "date-asc") {
            this.eventsList = this.filteredEvents.sort((a, b) => { return <any>new Date(a.startDate.toString()) - <any>new Date(b.startDate.toString()) });
            this.sortLabel = 'Upcoming';
            this.refreshEvents();
        } else if (order === "date-desc") {
            this.eventsList = this.filteredEvents.sort((a, b) => { return <any>new Date(b.startDate.toString()) - <any>new Date(a.startDate.toString()) });
            this.sortLabel = 'Newest';
            this.refreshEvents();
        } else if (order === "name-asc") {
            this.eventsList = this.filteredEvents.sort((a, b) => a.eventName.localeCompare(b.eventName));
            this.sortLabel = 'A-Z';
            this.refreshEvents();
        } else if (order === "name-desc") {
            this.eventsList = this.filteredEvents.sort((a, b) => b.eventName.localeCompare(a.eventName));
            this.sortLabel = 'Z-A';
            this.refreshEvents();
        }
    }

    openInNewWindow(eventId: string) {
        // Converts the route into a string that can be used 
        // with the window.open() function
        window.open(`/event/sessions?id=${eventId}`, '_blank')
    }
}
